import { getCompany, getConnector, getTaskAndTaskWorkflow, getUserAndEventTime } from './lib/index.js';
import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
export const createTimesheetsSyncedSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.TIMESHEETS_SYNCED,
        ...getUserAndEventTime(),
        ...getTaskAndTaskWorkflow(),
        data: {
            timesheets: [
                {
                    duration: 420,
                    date: '2021-10-13T12:00:00.000Z',
                    type: 'unpaid',
                    clockedIn: '2021-10-13T13:00:00.000Z',
                    clockedOut: '2021-10-13T20:00:00.000Z'
                },
                {
                    duration: 480,
                    date: '2021-10-12T12:00:00.000Z',
                    type: 'paid',
                    clockedIn: '2021-10-12T13:00:00.000Z',
                    clockedOut: '2021-10-12T21:00:00.000Z'
                },
                {
                    duration: 340,
                    date: '2021-10-11T12:00:00.000Z',
                    type: 'paid',
                    clockedIn: '2021-10-11T13:00:00.000Z',
                    clockedOut: '2021-10-11T18:40:00.000Z'
                }
            ],
            ...getCompany(),
            ...getConnector(),
            linkedAccount: '5f7212103a40e91f95ba376d'
        }
    };
};
//# sourceMappingURL=timesheets-synced.js.map